/* eslint-disable no-useless-concat */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */

import React from "react";
import Title from "../../extras/Title";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../extras/Table";
import Pagination from "../../extras/Pagination";
import Analytics from "../../extras/Analytics";
import { useNavigate } from "react-router-dom";
import { openDialog } from "../../../redux/slice/dialogueSlice";
import { deleteHoliday, getHoliday } from "../../../redux/slice/holidaySlice";
import Button from "../../extras/Button";
import HolidayDialog from "./HolidayDialog";
import { permissionError, warning } from "../../../util/Alert";
import { ReactComponent as Delete } from "../../../../src/assets/icon/delete.svg";
import { IconPlus, IconTrash } from "@tabler/icons-react";
const Holiday = () => {
  const { dialogue, dialogueType } = useSelector((state) => state.dialogue);
  const { holiday, total } = useSelector((state) => state.holiday);
  const hasPermission = useSelector((state) => state.auth.admin.flag);

  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [startDate, setStartDate] = useState("ALL");
  const [endDate, setEndDate] = useState("ALL");
  const navigate = useNavigate();

  useEffect(() => {
    const payload = {
      start: page,
      limit: rowsPerPage,
      startDate,
      endDate,
    };
    dispatch(getHoliday(payload));
  }, [page, rowsPerPage, startDate, endDate]);

  useEffect(() => {
    setData(holiday);
  }, [holiday]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event, 10));
    setPage(0);
  };

  const bookingTable = [
    {
      Header: "No",
      Cell: ({ index }) => (
        <span>{page * rowsPerPage + parseInt(index) + 1}</span>
      ),
    },
    {
      Header: "Name",
      body: "name",
      Cell: ({ row }) => (
        <span className="text-capitalize  cursor">
          {row?.salonId?.name}
        </span>
      ),
    },
    

    {
      Header: "Reason",
      Cell: ({ row }) => (
        <span className="text-capitalize">
          {row?.reason ? row?.reason : "-"}
        </span>
      ),
    },
    {
      Header: "Date",
      sorting: { type: "client" },
      body: "date",
      Cell: ({ row }) => (
        <span className="text-capitalize  cursor">{row?.date}</span>
      ),
    },
    {
      Header: "Delete",
      Cell: ({ row }) => (
        <div className="action-button">
          <button
            className="btn btn-sm"
            onClick={() => handleDelete(row?._id)}
          >
           <IconTrash className="text-secondary"/>
          </button>
        </div>
      ),
    },
  ];

  const handleDelete = (id) => {
    if (!hasPermission) return permissionError();
    const data = warning("Delete");
    data
      .then((logouts) => {
        const yes = logouts.isConfirmed;
        console.log("yes", yes);
        if (yes) {
          dispatch(deleteHoliday(id));
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <div className="userPage">
        <div className="d-flex justify-content-end mb-3">

          <Analytics
            analyticsStartDate={startDate}
            analyticsStartEnd={endDate}
            analyticsStartDateSet={setStartDate}
            analyticsStartEndSet={setEndDate}
          />
        </div>
        <div className="user-table mb-3">
          <div className="user-table-top">
            <div className=" d-flex justify-content-between align-items-center w-100 ">
              <div className="w-100">
                <h5
                  className="main-title">
                  Holiday
                </h5>
              </div>
              <div className="d-flex gap-2 justify-content-end w-100">
                <Button
                  text={`Add holiday`}
                  bIcon={<IconPlus size={18} />}
                  onClick={() => {
                    dispatch(openDialog({ type: "holiday" }));
                  }}
                />
              </div>
            </div>
          </div>
       
          <Table
            data={data}
            mapData={bookingTable}
            serverPerPage={rowsPerPage}
            type={"server"}
          />
          <Pagination
            type={"server"}
            serverPage={page}
            setServerPage={setPage}
            serverPerPage={rowsPerPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            totalData={total}
          />
        
        </div>



      </div>

      {dialogue && dialogueType === "holiday" && (
        <HolidayDialog
          setData={setData}
          data={data}
        />
      )}
    </>
  );
};
export default Holiday;
